import { MenuItem, Box } from '@chakra-ui/react'
import { useColorModeValue } from '@chakra-ui/react'

export const CountryItem = ({ onClick, isActive, data }) => {
  const activeBg = useColorModeValue('gray.50')
  const { flagIcon, countryName, phoneCode } = data

  return (
    <MenuItem
      onClick={onClick}
      bg={isActive ? activeBg : 'transparent'}
      display="block"
      padding="13px 15px"
    >
      <Box display="flex" gap={2} alignItems="center">
        <Box height="33px" fontSize={25}>
          {flagIcon}
        </Box>
        <Box
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxWidth="220px"
        >
          {countryName}
        </Box>
        <Box>({phoneCode})</Box>
      </Box>
    </MenuItem>
  )
}
